import { Spin, Modal, Steps, PageHeader, Tag, Row, Table, Select } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import service from '../../../../@services'
import './index.less'
import ProductTable from '../ProductTable'
import { connect } from 'react-redux'
import BasicDescription from '../BasicDescription'
import { activityStatusMap } from '../../../Activity/config'
const { Step } = Steps
/** 操作日志字段列表 */
const columns = [
  {
    title: '操作类型',
    dataIndex: 'operatorType',
    align: 'center'
  },
  {
    title: '操作描述',
    dataIndex: 'operDesc',
    align: 'center'
  },
  {
    title: '操作人',
    dataIndex: 'operatorName',
    align: 'center'
  },
  {
    title: '操作时间',
    dataIndex: 'operTime',
    align: 'center'
  }
]
const PopupDetail = props => {
  const {
    orderChan,
    orderStatus,
    orderType,
    visible,
    onClose,
    detail = {}
  } = props
  const [loading, setLoading] = useState(false)
  const [orderDetail, setOrderDetail] = useState({})
  const [orderStep, setOrderStep] = useState(1)
  const [newOrderStatus, setNewOrderStatus] = useState([])
  /** 基本信息描述字段及组件列表 */
  const fileds = [
    {
      label: '订单来源',
      value: 'chan',
      render: text =>
        ((orderChan || []).filter(item => item.code == text)[0] || []).name
    },
    {
      label: '订单类型',
      value: 'orderTypeName'
    },
    { label: '下单时间', value: 'orderTime' },
    {
      label: '订单状态',
      value: 'orderStatusName'
    },
    {
      label: '支付方式',
      value: 'payWays',
      span: 2,
      contentStyle: { flexDirection: 'column' },
      render: text =>
        text && text.map((item, index) => <div key={index}>{item}</div>)
    },
    { label: '收银员', value: 'cashierName' },
    { label: '配送方式', value: 'receiveWay' },
    { label: '购买人姓名', value: 'buyerName' },
    { label: '购买人电话', value: 'buyerPhone' },
    { label: '收件人', value: 'receiverName' },
    { label: '联系方式', value: 'receiverPhone' },
    { label: '收货地址', value: 'receiverDetailAddr' }
  ]

  useEffect(() => {
    setLoading(true)
    if (visible && detail.orderNo) {
      const api = detail.isDelivery
        ? service.delivery.detailByNo(detail.orderNo)
        : service.order.getOrderDetail(detail.orderNo)
      console.log('TODO:订单流转状态相关需求修改-还未请求', detail, '......', api)
      api
        .then(data => {
          setOrderDetail(data || {})
          setLoading(false)
          if (data) {
            if (data.chan === 'tc_online') {
              console.log('TODO:订单流转状态相关需求修改-请求成功', data)
              if (data.orderStatus === 'cancel') {
                const cancelStep = data.traces[data.traces.length - 2].operTag
                let orderStep = 0
                const orderStatusOptions = []
                let OrderStatusMap = []
                if (data.orderType === 2) {
                  OrderStatusMap = [
                    { key: 'wait_pay', value: '待付款' },
                    { key: 'wait_group', value: '待成团' },
                    { key: 'grouped', value: '已成团' },
                    { key: 'wait_take', value: '待自提' },
                    { key: 'finish', value: '已完成' }
                  ]
                } else if (data.orderType === 3) {
                  if (data.receiveWay === '门店自提') {
                    OrderStatusMap = [
                      { key: 'wait_pay', value: '待付款' },
                      { key: 'wait_take', value: '待自提' },
                      { key: 'finish', value: '已完成' },
                    ]
                  } else {
                    OrderStatusMap = [
                      { key: 'wait_pay', value: '待付款' },
                      { key: 'wait_delivery', value: '待发货' },
                      { key: 'wait_take', value: '待自提' },
                      { key: 'finish', value: '已完成' }
                    ]
                  }
                }
                for (let i = 0; i < OrderStatusMap.length; i++) {
                  const item = OrderStatusMap[i]
                  if (data.receiveWay === '快递配送' && item.key === 'wait_take') item.value = '待收货'
                  if (i === 2 && data.receiveWay === '门店自提' && data.orderType === 3 && cancelStep !== 'finish') {
                    OrderStatusMap.splice(2, 1)
                    orderStep = i + 1
                    break
                  }
                  orderStatusOptions.push(item.value)
                  if (item.key === cancelStep || item.value === cancelStep) {
                    orderStep = i + 1
                    break
                  }
                }
                orderStatusOptions.push('已取消')
                console.log('TODO:订单流转状态相关需求修改data.orderStatus===cancel', orderStatusOptions)
                setNewOrderStatus(orderStatusOptions)
                setOrderStep(orderStep + 1)
              } else {
                let OrderStatusMap = []
                if (data.orderType === 2) {
                  OrderStatusMap = [
                    { key: 'wait_pay', value: '待付款' },
                    { key: 'wait_group', value: '待成团' },
                    { key: 'grouped', value: '已成团' },
                    { key: 'wait_take', value: '待自提' },
                    { key: 'finish', value: '已完成' }
                  ]
                } else if (data.orderType === 3) {
                  if (data.receiveWay === '门店自提') {
                    OrderStatusMap = [
                      { key: 'wait_pay', value: '待付款' },
                      { key: 'wait_take', value: '待自提' },
                      { key: 'finish', value: '已完成' },
                    ]
                  } else {
                    OrderStatusMap = [
                      { key: 'wait_pay', value: '待付款' },
                      { key: 'wait_delivery', value: '待发货' },
                      { key: 'wait_take', value: '待自提' },
                      { key: 'finish', value: '已完成' }
                    ]
                  }
                }
                const orderStatusOptions = OrderStatusMap.map((item, index) => {
                  if (data.orderStatus.indexOf(item.key) > -1) {
                    setOrderStep(index)
                  }
                  if (data.receiveWay === '快递配送' && item.key === 'wait_take') {
                    item.value = '待收货'
                  }
                  return item.value
                })
                console.log('TODO:订单流转状态相关需求修改else', orderStatusOptions)
                setNewOrderStatus(orderStatusOptions)
              }
            } else {
              data.orderStatus === 'finish' && setOrderStep(2)
            }
          }
        })
        .catch(e => {
          setLoading(false)
        })
    } else {
      setLoading(false)
      setOrderDetail({})
      setOrderStep(0)
    }
  }, [visible])
  return (
    <Modal
      title='订单详情'
      centered
      footer={null}
      visible={visible}
      onCancel={onClose}
      width={1000}
      className='order-detail-popup'>
      <Spin spinning={loading}>
        <PageHeader
          title={
            <>
              <FileTextOutlined
                style={{ color: '#1890FF', marginRight: '5px' }}
              />
              <span style={{ color: '#1890FF' }}>
                订单号：{orderDetail.orderNo}
              </span>
            </>
          }
          tags={
            orderDetail.orderStatusName && (
              <Tag color='green'>{orderDetail.orderStatusName}</Tag>
            )
          }>
          {orderDetail.chan === 'tc_online' ? (
            <Steps labelPlacement='vertical' current={orderStep} size='small'>
              {newOrderStatus &&
                newOrderStatus.map(item => {
                  return <Step key={item} title={item} description={''} />
                })}
            </Steps>
          ) : (
            <Steps labelPlacement='vertical' current={orderStep} size='small'>
              <Step title='待付款' />
              <Step title='已完成' />
            </Steps>
          )}
        </PageHeader>
        <PageHeader className='detail-head' title='订单基础信息'>
          <BasicDescription
            detail={orderDetail}
            column={{ xs: 1, sm: 2, md: 3 }}
            fileds={fileds}
          />
        </PageHeader>
        <PageHeader
          className='detail-head'
          title='商品信息'
          extra={
            <Row>
              共
              <span className='primary-text'>
                {(orderDetail &&
                  orderDetail.details &&
                  orderDetail.details.length) ||
                  0}
              </span>
              种商品，总金额
              <span className='primary-text'>
                {orderDetail.productAmount || 0}
              </span>
              元， 实付金额
              <span className='primary-text'>{orderDetail.payAmount || 0}</span>
              元
            </Row>
          }>
          <ProductTable data={orderDetail.details || []} />
          <div className='detail-row'>
            <span>商品总金额</span>
            <span>￥{orderDetail.productAmount || 0}</span>
          </div>
          <div className='detail-row'>
            <span>包装费</span>
            <span>￥{orderDetail.packageAmount || 0}</span>
          </div>
          <div className='detail-row'>
            <span>配送费</span>
            <span>￥{orderDetail.freightAmount || 0}</span>
          </div>
          <div className='detail-row right'>
            <span>实付总金额</span>
            <span style={{ marginLeft: '20px' }}>
              ￥{orderDetail.payAmount || 0}
            </span>
          </div>
          <div className='detail-row'>
            用户留言：{orderDetail.buyerRemark || '-'}
          </div>
        </PageHeader>
        <PageHeader className='detail-head' title='操作日志'>
          <Table
            rowKey={record => record.operTag + record.operTime}
            size='middle'
            bordered
            columns={columns}
            dataSource={orderDetail.traces || []}
            pagination={false}
          />
        </PageHeader>
      </Spin>
    </Modal>
  )
}
export default connect(state => ({
  orderChan: state.order.orderChan,
  orderType: state.order.orderType,
  orderStatus: state.order.orderStatus
}))(PopupDetail)
